import { t } from "@lingui/macro";
import React, { useState } from "react";

import {
  VStack,
  Text,
  Box,
  HStack,
} from "@whoosh/design-system/src/components/primitive";

import { Button } from "../../../../components/controls/Button/Button";
import { MarkdownDisplay } from "../../../../components/display/MarkdownDisplay/MarkdownDisplay";
import { AlertIcon } from "../../../../components/icons_v2/general";
import { PopUpModal } from "../../../../components/overlay/PopUpModal";

type Props = {
  header?: string;
  body?: string;
  priority?: "HIGH" | "MEDIUM" | "STANDARD";
  variant?: "inline" | "underlay";
};

export const CourseNote = ({
  body,
  header,
  priority = "STANDARD",
  variant = "inline",
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const bgColor =
    priority === "HIGH"
      ? "surface-status-error-subtle"
      : priority === "MEDIUM"
      ? "surface-status-warning-subtle"
      : "surface-dividers";

  const borderRadiusTop = variant === "underlay" ? 0 : 16;
  const borderRadiusBottom = variant === "underlay" ? 24 : 16;
  const topPadding = variant === "underlay" ? 10 : 3;

  return (
    <>
      <HStack
        px={4}
        pb={3}
        pt={topPadding}
        bg={bgColor}
        alignItems="center"
        overflow="hidden"
        gap={2}
        style={{
          borderTopLeftRadius: borderRadiusTop,
          borderTopRightRadius: borderRadiusTop,
          borderBottomLeftRadius: borderRadiusBottom,
          borderBottomRightRadius: borderRadiusBottom,
        }}
      >
        <HStack gap={2} flex={1} alignItems="center">
          <Box height={16} width={16}>
            <AlertIcon />
          </Box>
          <Text
            maxFontSizeMultiplier={2}
            variant="mainBaseSemiBold"
            flex={1}
            numberOfLines={2}
          >
            {header}
          </Text>
        </HStack>
        <Box flexShrink={0}>
          <Button
            variant="white"
            size="tiny"
            onPress={() => setIsModalOpen(true)}
            testID="course-note-read-more-button"
            accessibilityLabel={t`Course Note Read More Button`}
          >{t`Read More`}</Button>
        </Box>
      </HStack>
      <PopUpModal
        isOpen={isModalOpen}
        isConfirmDisabled={false}
        onClose={(confirm: boolean) => {
          setIsModalOpen(false);
        }}
        cancelText={t`Dismiss`}
        upperTitle={header}
        content={
          <VStack>
            <MarkdownDisplay markdown={body ?? ""} />
          </VStack>
        }
      />
    </>
  );
};
